import React from 'react';
import createSvgIcon from '@mui/material/utils/createSvgIcon.js';

export default createSvgIcon(
  <path
    d="M19.1 15.8c.2.2.3.6.1.8l-.1.1L18 18h1.3c.5 0 .8.3.9.8v.1c0 .2 0 .3-.1.5l-.1.1-1.9 2.4c-.2.3-.6.3-.9.1s-.3-.6-.2-.8V21l1.4-1.7H17c-.2 0-.4-.1-.5-.2l-.1-.1c-.3-.3-.4-.8-.1-1.2l.1-.1 1.8-1.9c.2-.2.6-.2.9 0M14.3 2.3l4.3 4.3c.4.4.4 1 .1 1.4l-2.9 2.9.8.8c.4.4.4 1 0 1.3L13 16.6c-.4.4-1 .4-1.3 0l-.8-.8L8 18.7c-.4.4-1 .4-1.3 0l-4.3-4.3c-.4-.4-.4-1-.1-1.4l2.9-2.9-.8-.7c-.4-.4-.4-1 0-1.3L8 4.5c.4-.4 1-.4 1.3 0l.8.8 2.9-3c.4-.3 1-.3 1.3 0m-10 10.6-.8.8 3.8 3.8.8-.8zm1.8-1.8-.9.9L9 15.8l.9-.9zm2.6-5.5L5.6 8.7l6.6 6.6 3.1-3.1zm3.2-.4-.9.9 3.8 3.8.9-.9zm1.8-1.7-.8.8 3.8 3.8.8-.8z"
    className="st0"
  />,
  'TaskingDashboard',
);
